import { X, Search, SlidersHorizontal } from 'lucide-react';

import { countFilterKeys, truncate } from './utils';

export const MapActiveContextBar = ({
  searchQuery = '',
  searchFilters = '',
  onClearQuery = () => {},
  onClearFilters = () => {},
  onEditFilters = () => {},
}) => {
  const filterCount = countFilterKeys(searchFilters);
  const hasQuery = Boolean(searchQuery);
  const hasFilters = filterCount > 0;

  if (!hasQuery && !hasFilters) return null;

  return (
    <div className="absolute left-2 right-2 top-[62px] flex flex-wrap gap-1.5 z-[2] pointer-events-none">
      {hasQuery && (
        <Chip
          icon={Search}
          label={`"${truncate(searchQuery)}"`}
          onClear={onClearQuery}
        />
      )}
      {hasFilters && (
        <Chip
          icon={SlidersHorizontal}
          label={`Filters (${filterCount})`}
          onBody={onEditFilters}
          onClear={onClearFilters}
        />
      )}
    </div>
  );
};

const Chip = ({ icon: Icon, label, onBody, onClear }) => {
  const Body = onBody ? 'button' : 'div';
  return (
    <div className="flex items-center bg-whiteColor border border-gray-200 rounded-full shadow-sm pointer-events-auto opacity-95">
      <Body
        type={onBody ? 'button' : undefined}
        onClick={onBody}
        className={`flex items-center gap-1.5 pl-2.5 pr-2 py-1 text-xs text-blackColor ${onBody ? 'cursor-pointer' : ''}`}
      >
        <Icon size={12} />
        <span className="font-medium">{label}</span>
      </Body>
      <button
        type="button"
        onClick={onClear}
        className="flex items-center justify-center pl-1 pr-2 py-1 text-gray-500 hover:text-blackColor"
        aria-label="Clear"
      >
        <X size={14} />
      </button>
    </div>
  );
};
